//#region react import
import { useRef, useState, useEffect } from "react";
import { createPortal } from "react-dom";
//#endregion

//#region functions import
import useClickOutside from "../../Helper/CustomHook/useClickOutside";
//#endregion

//#region components import
import Loader from "../Loader/Loader.component";
//#endregion

//#region style import
import "./GstaModal.style.scss";
//#endregion

const GstaModal = ({
  modalOpen,
  goToPreviousModalPage,
  handleCloseModal,
  handleValidate,
  title,
  iconTitle,
  children,
  cancelText,
  validText,
  FooterAddedComponent,
  FooterAddedComponentProps,
  validateDisabled,
  hasTableInside,
  className,
  loading,
  loadingText,
  disableUseClickOutside,
  validIcon,
  cancelIcon,
  overrideStyle,
  currentPage,
  maxNumberPage,
}) => {
  //#region state
  const [mounted, setMounted] = useState(false);
  //#endregion
  //#region constants
  //#endregion

  //#region others use...
  const ref = useRef();
  useClickOutside(disableUseClickOutside ? [] : [ref], modalOpen, handleCloseModal);
  //#endregion

  //#region functions
  const getCancelButtonStyle = () => {
    if (!cancelText) return { display: "none" };
    else return { visibility: "visible" };
  };

  const getValidatedButtonStyle = () => {
    if (!validText) return { display: "none" };
    else return { visibility: "visible" };
  };

  const isSingleButton = !FooterAddedComponent && ((cancelText && !validText) || !cancelText);

  //#endregion

  //#region useQuery
  //#endregion

  //#region useEffect
  useEffect(() => {
    setMounted(true);
  }, []);
  //#endregion

  if (!mounted) return null;
  return (
    <>
      {modalOpen &&
        createPortal(
          <div className={"modal " + className}>
            <div
              className={hasTableInside ? "modal-content-table" : "modal-content"}
              ref={ref}
              isloading={loading?.toString()}
              style={overrideStyle}
            >
              <header className="modal-title">
                <div>
                  {iconTitle && <i className={iconTitle} />}
                  <h1>{title}</h1>
                </div>
                {currentPage && maxNumberPage && (
                  <span>
                    {currentPage} / {maxNumberPage}
                  </span>
                )}
              </header>
              {loading ? (
                <div className="modal-loader">
                  <Loader loadingText={loadingText} />
                </div>
              ) : (
                <div className={"modal-main"}>{children}</div>
              )}
              {!loading && (
                <div className={`modal-action ${isSingleButton ? "modal-action-single-button" : ""}`}>
                  <>
                    <button
                      style={getCancelButtonStyle()}
                      className={"modal-action-button-cancel"}
                      onClick={currentPage && maxNumberPage ? goToPreviousModalPage : handleCloseModal}
                      data-testid={"modal-cancel"}
                    >
                      {cancelIcon ? <i className={cancelIcon} /> : <i className="icon-undo" />}
                      <span>{cancelText}</span>
                    </button>
                    {FooterAddedComponent && (
                      <FooterAddedComponent FooterAddedComponentProps={FooterAddedComponentProps} />
                    )}
                    <button
                      style={getValidatedButtonStyle()}
                      className={"modal-action-button-validate"}
                      onClick={handleValidate}
                      data-testid={"modal-validate"}
                      disabled={validateDisabled}
                    >
                      <span>{validText}</span>
                      {validIcon ? <i className={validIcon} /> : <i className="icon-check" />}
                    </button>
                  </>
                </div>
              )}
            </div>
          </div>,
          document.getElementById("modal-root")
        )}
    </>
  );
};

export default GstaModal;
